// extracted by mini-css-extract-plugin
module.exports = {"loading":"Player_loading__bSCQ6","hidePlayer":"Player_hidePlayer__1ORn2"};